<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <StockInward />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import StockInward from "./components/StockInward";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    StockInward,
    // ProjectsTable,
  },
};
</script>
